import Icon from "@web-ui/components/Icon";
import Tooltip from "@web-ui/components/Tooltip";
import type { Definition } from "../definitions";

/**
 * A metric's name with its plain one-sentence meaning (definitions.ts) one hover, tap or Tab away:
 * the kit tooltip around its help icon, made focusable and named for screen readers.
 */
export function MetricLabel({ definition, className }: { definition: Definition; className?: string }) {
  return (
    <span className={`inline-flex items-center gap-1.5 ${className || ""}`}>
      {definition.label}
      <Tooltip content={definition.tooltip} place="top">
        <span role="img" tabIndex={0} aria-label={`${definition.label}: ${definition.tooltip}`} className="inline-flex rounded-full focus-visible:outline-2 focus-visible:outline-s-focus">
          <Icon name="help" size={4} className="fill-inherit" />
        </span>
      </Tooltip>
    </span>
  );
}
